import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="footer-top-wrap">
        <div className="container">
          <div className="footer-quick-link-wrap">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="footer-logo">
                  <Link to="/"><img src="img/logo/white-logo-with-transparent-bg.png" width={250} height={120} alt="Logo" /></Link>
                </div>
                <div className="quick-link-list">
                  <ul>
                    <li><a href="/#">FAQ</a></li>
                    <li><a href="/#">Help Center</a></li>
                    <li><a href="/#">Terms of Use</a></li>
                    <li><a href="/#">Privacy</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer-social">
                  <ul>
                    <li><a href="/#"><i className="fab fa-facebook-f" /></a></li>
                    <li><a href="/#"><i className="fab fa-twitter" /></a></li>
                    <li><a href="/#"><i className="fab fa-pinterest-p" /></a></li>
                    <li><a href="/#"><i className="fab fa-linkedin-in" /></a></li>
                    <li><a href="https://www.instagram.com/satrangmediaproductions"><span className="fab fa-instagram" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="copyright-text">
                <p>Copyright © 2025. All Rights Reserved By <a href="/#">Satrang Media & Productions</a></p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer